import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/deskpro': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M205.9 512L237 473.6C249.3 473.4 262.6 472.2 273.5 467 312.4 448.4 311.9 405.1 311.8 403.2 311.7 398.2 311 398.8 282.9 365.8H362C361.8 415.9 354.7 434.3 351.8 441.5 342.4 465.2 307.9 504.3 256.6 510.9 247.9 512 223.8 512.1 205.9 512zM406.3 344.3C444.9 344.3 464.8 330.7 480 313.4L304.5 313.1 287.1 344.4 406.3 344.3zM362.7 120.4V288.7H289.2L256.5 344.2H250C197.7 344.2 191.9 287.7 191.7 285.3 190.5 272.1 170.4 273.7 171.6 287.1 173 302.9 180.4 327.1 198 344.2H107C81.5 344.2-3.8 317.4 0 230.2V16.9C0 0.9 9.7 0.3 15 0.1H97C97.2 0.1 97.3 0.2 97.5 0.2 101.8-0.2 147.6-1.9 147.6 43.9 147.6 57.2 167.8 57.3 167.8 43.9 167.8 25.7 162.3 11.1 152 0.2H236.2C344.9-0.2 362.7 79.6 362.7 120.4zM230.2 176.4L294.2 205.7C307.5 160.2 252 134 230.2 176.4z'
      }
    ]
  }
})
